import type { SanityDivider } from '#/lib/sanity/queries/sections';
import { COLORS } from '#/lib/utils';

const THEME_COLORS: Record<
  SanityDivider['theme'],
  { background: string; line: string }
> = {
  white: { background: COLORS.cloud, line: COLORS.grayscale['02'] },
  gray: { background: COLORS.grayscale['01'], line: COLORS.cipher['02'] },
  dark: { background: COLORS.charcoal, line: COLORS.grayscale['05'] },
  cipher: { background: COLORS.cipher.DEFAULT, line: COLORS.cloud },
};

export function Divider(props: SanityDivider) {
  const { background, line } = THEME_COLORS[props.theme] ?? THEME_COLORS.white;

  return (
    <div style={{ background }} className="py-[20px]">
      <div className="fade-in p-main">
        <div className="mx-auto max-w-[1235px]">
          <hr className="border-t-1" style={{ borderColor: line }} />
        </div>
      </div>
    </div>
  );
}
